var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaladBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 357,
    viewBox: "0 0 299 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.5 303.823L299 217.016L149.5 130.203V303.823Z",
    fill: "#DCEBC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 217.016L149.5 303.822L0 390.628V217.016Z",
    fill: "#B1D235"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.5 303.822L0 390.629L149.5 477.435V303.822Z",
    fill: "#DCEBC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0133409 325.523L0 325.53V347.218L0.0133409 347.225L18.6875 336.381V336.367L0.0133409 325.523Z",
    fill: "#224F26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0133409 195.314L0 195.321V217.009L0.0133409 217.016L18.6875 206.172V206.158L0.0133409 195.314Z",
    fill: "#224F26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6875 358.076V336.374L0 347.225L18.6875 358.076Z",
    fill: "#B1D235"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6875 336.374V314.673L0 325.524L18.6875 336.374Z",
    fill: "#54A746"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6875 314.673V292.972L0 303.822L18.6875 314.673Z",
    fill: "#B1D235"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6875 162.762V141.061L0 151.911L18.6875 162.762Z",
    fill: "#B1D235"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3617 282.12L37.375 282.127V303.815L37.3617 303.822L18.6875 292.978V292.964L37.3617 282.12Z",
    fill: "#B1D235"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3617 260.419L37.375 260.426V282.114L37.3617 282.121L18.6875 271.277V271.263L37.3617 260.419Z",
    fill: "#224F26"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6875 249.568V227.866L37.375 238.717L18.6875 249.568Z",
    fill: "#B1D235"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3883 347.226L37.375 347.232V368.92L37.3883 368.927L56.0625 358.083V358.07L37.3883 347.226Z",
    fill: "#54A746"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3883 282.12L37.375 282.127V303.815L37.3883 303.822L56.0625 292.978V292.964L37.3883 282.12Z",
    fill: "#B1D235"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1525 314.334L50.1392 314.341V336.029L50.1525 336.036L68.8267 325.192V325.178L50.1525 314.334Z",
    fill: "#54A746"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0625 358.076V336.374L37.375 347.225L56.0625 358.076Z",
    fill: "#B1D235"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0625 336.374V314.673L37.375 325.524L56.0625 336.374Z",
    fill: "#B1D235"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0625 314.673V292.972L37.375 303.822L56.0625 314.673Z",
    fill: "#B1D235"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0625 249.568V227.866L37.375 238.717L56.0625 249.568Z",
    fill: "#B1D235"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0625 206.164V184.463L37.375 195.314L56.0625 206.164Z",
    fill: "#B1D235"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7634 347.226L74.75 347.232V368.92L74.7634 368.927L93.4375 358.083V358.07L74.7634 347.226Z",
    fill: "#B1D235"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7634 325.523L74.75 325.53V347.218L74.7634 347.225L93.4375 336.381V336.367L74.7634 325.523Z",
    fill: "#B1D235"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7634 303.822L74.75 303.829V325.517L74.7634 325.524L93.4375 314.68V314.666L74.7634 303.822Z",
    fill: "#54A746"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7634 282.12L74.75 282.127V303.815L74.7634 303.822L93.4375 292.978V292.964L74.7634 282.12Z",
    fill: "#B1D235"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7634 260.419L74.75 260.426V282.114L74.7634 282.121L93.4375 271.277V271.263L74.7634 260.419Z",
    fill: "#B1D235"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7634 238.717L74.75 238.724V260.412L74.7634 260.418L93.4375 249.574V249.561L74.7634 238.717Z",
    fill: "#224F26"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7634 173.612L74.75 173.619V195.307L74.7634 195.314L93.4375 184.47V184.456L74.7634 173.612Z",
    fill: "#81BA41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4375 336.374V314.673L74.75 325.524L93.4375 336.374Z",
    fill: "#224F26"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.138 282.12L112.125 282.127V303.815L112.138 303.822L130.812 292.978V292.964L112.138 282.12Z",
    fill: "#B1D235"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.138 238.717L112.125 238.724V260.412L112.138 260.418L130.812 249.574V249.561L112.138 238.717Z",
    fill: "#54A746"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.812 358.076V336.374L112.125 347.225L130.812 358.076Z",
    fill: "#54A746"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.812 271.27V249.568L112.125 260.419L130.812 271.27Z",
    fill: "#224F26"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.812 249.568V227.866L112.125 238.717L130.812 249.568Z",
    fill: "#B1D235"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.812 206.164V184.463L112.125 195.314L130.812 206.164Z",
    fill: "#54A746"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.888 282.12L186.875 282.127V303.815L186.888 303.822L205.562 292.978V292.964L186.888 282.12Z",
    fill: "#54A746"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.888 260.419L186.875 260.426V282.114L186.888 282.121L205.562 271.277V271.263L186.888 260.419Z",
    fill: "#54A746"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.888 151.911L186.875 151.918V173.606L186.888 173.613L205.562 162.769V162.755L186.888 151.911Z",
    fill: "#54A746"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.888 130.209L186.875 130.216V151.904L186.888 151.911L205.562 141.067V141.053L186.888 130.209Z",
    fill: "#54A746"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.562 271.27V249.568L186.875 260.419L205.562 271.27Z",
    fill: "#54A746"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.562 249.568V227.866L186.875 238.717L205.562 249.568Z",
    fill: "#B1D235"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.562 206.164V184.463L186.875 195.314L205.562 206.164Z",
    fill: "#B1D235"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.237 303.822L224.25 303.829V325.517L224.237 325.524L205.562 314.68V314.666L224.237 303.822Z",
    fill: "#B1D235"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.237 238.717L224.25 238.724V260.412L224.237 260.418L205.562 249.574V249.561L224.237 238.717Z",
    fill: "#B1D235"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.237 173.612L224.25 173.619V195.307L224.237 195.314L205.562 184.47V184.456L224.237 173.612Z",
    fill: "#B1D235"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.237 130.209L224.25 130.216V151.904L224.237 151.911L205.562 141.067V141.053L224.237 130.209Z",
    fill: "#B1D235"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.562 249.568V227.866L224.25 238.717L205.562 249.568Z",
    fill: "#54A746"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.938 314.673V292.972L261.625 303.822L242.938 314.673Z",
    fill: "#B1D235"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.938 271.27V249.568L261.625 260.419L242.938 271.27Z",
    fill: "#54A746"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.938 227.867V206.165L261.625 217.016L242.938 227.867Z",
    fill: "#B1D235"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.938 184.463V162.762L261.625 173.613L242.938 184.463Z",
    fill: "#B1D235"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.112 347.226L112.125 347.232V368.92L112.112 368.927L93.4375 358.083V358.07L112.112 347.226Z",
    fill: "#B1D235"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.112 325.523L112.125 325.53V347.218L112.112 347.225L93.4375 336.381V336.367L112.112 325.523Z",
    fill: "#224F26"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4375 336.374V314.673L112.125 325.524L93.4375 336.374Z",
    fill: "#54A746"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4375 314.673V292.972L112.125 303.822L93.4375 314.673Z",
    fill: "#B1D235"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4375 292.971V271.27L112.125 282.12L93.4375 292.971Z",
    fill: "#224F26"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.487 282.12L149.5 282.127V303.815L149.487 303.822L130.812 292.978V292.964L149.487 282.12Z",
    fill: "#54A746"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.487 260.419L149.5 260.426V282.114L149.487 282.121L130.812 271.277V271.263L149.487 260.419Z",
    fill: "#54A746"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.812 336.374V314.673L149.5 325.524L130.812 336.374Z",
    fill: "#B1D235"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.513 325.523L149.5 325.53V347.218L149.513 347.225L168.188 336.381V336.367L149.513 325.523Z",
    fill: "#DCEBC0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.513 260.419L149.5 260.426V282.114L149.513 282.121L168.188 271.277V271.263L149.513 260.419Z",
    fill: "#B1D235"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.513 217.016L149.5 217.022V238.71L149.513 238.717L168.188 227.873V227.86L149.513 217.016Z",
    fill: "#224F26"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.513 130.209L149.5 130.216V151.904L149.513 151.911L168.188 141.067V141.053L149.513 130.209Z",
    fill: "#224F26"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.513 0L149.5 0.00678174V21.6948L149.513 21.7016L168.188 10.8576V10.844L149.513 0Z",
    fill: "#224F26"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.188 314.673V292.972L149.5 303.822L168.188 314.673Z",
    fill: "#B1D235"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.188 249.568V227.866L149.5 238.717L168.188 249.568Z",
    fill: "#54A746"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.188 206.164V184.463L149.5 195.314L168.188 206.164Z",
    fill: "#54A746"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.188 184.463V162.762L149.5 173.613L168.188 184.463Z",
    fill: "#54A746"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.188 97.6567V75.9551L149.5 86.8059L168.188 97.6567Z",
    fill: "#224F26"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.188 75.9555V54.2539L149.5 65.1047L168.188 75.9555Z",
    fill: "#B1D235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaladBackground);
export default __webpack_public_path__ + "static/media/salad-background.7486b7ac9a79a6fe1c5786a5ff5b12fa.svg";
export { ForwardRef as ReactComponent };